(function($) {
	var debugHandler = function(event, realEvent, App) {
		console.log('[AppEvent][' + realEvent + ']');
	};	
	
	window.App = (function() {
		//Construceur Appli principal
		function App() {
			//Constructeur des composants
			this.Component = {};
			this.instances = {};
			this.Util = {
				//GetYoDigits
				generateId: function (length, componentName) {
					length = length || 6;
					//Eg: dmeu7o-Engine
					return (componentName ? componentName + '-' : '') + Math.round(Math.pow(36, length + 1) - Math.random()
						* Math.pow(36, length)).toString(36).slice(1);
				}
			};
			//Detection de navigateur
			this.BrowserDetection = {
				//Internet Explorer 9
				isIe9: function () {
					if (navigator.appName.indexOf("Internet Explorer") != -1) {
						return navigator.appVersion.indexOf("MSIE 9") !== -1;
					}
					return false;
				},
				isIe : function()
				{
					return (navigator.userAgent.indexOf("Internet Explorer") != -1)
						|| (navigator.userAgent.indexOf('Trident/') !== -1);
				},
				isApple: function () {
					return navigator.userAgent.match(/(iPod|iPhone|iPad)/);
				}
			};
			this.debug = function(enableDebug) {
				this.isDebug = enableDebug;
				if (enableDebug) {
					$.subscribe('Debug', debugHandler);
				} else {
					$.unsubscribe('Debug', debugHandler);
				}
			};
			this.isDebug = false;
		};
			
		//Singleton
		var currentApp = new App();
		return currentApp;
	})();
	
	//Gestion des évènements via un objet
	var o = $({});
	$.subscribe = function () {
		o.on.apply(o, arguments);
	};
	$.unsubscribe = function () {
		o.off.apply(o, arguments);
	};
	$.publish = function () {
		var event = arguments[0];
		if (window.App.isDebug) {
			debugEvents(event);
		}
		o.trigger.apply(o, arguments);
	};
	
	var debugEvents = function(realEvent) {
		if (realEvent !== 'Debug') {
			$.publish('Debug', [realEvent, window.App]);
		}
	};	
		
		
	//Evenements de l'appli
	window.App.Events = o[0];
	
	//Récupère un composant à partir du premier parent [data-component]
	$.fn.getComponent = function() {
		var isSelfComponent = typeof $(this).data('component') !== 'undefined';
		var parentComponent = isSelfComponent ? $(this) : $(this).first().parents('[data-component]');
		var componentData = parentComponent.data('component');
		var componentId = parentComponent.data('componentId');
		if (typeof componentData.type === 'undefined') {
			console.warn('Data du Composant non trouvé');
			return false;
		} else if (!$.isArray(App.instances[componentData.type])) {
			console.warn('Aucun composant de type ' + componentData.type);
			return false;
		}
		var foundComponent = null;
		App.instances[componentData.type].forEach(function(component) {
			if (component.id === componentId) {
			foundComponent = component;
		  }
		});
		return foundComponent;
	};
})(jQuery);